module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo5-dd686fb306b73dfb5fc3ef3946806d61.png";